import { ScreensaverState, SHOW_SCREENSAVER, SHOW_TIMEOUT_WARNING } from './types';
import { Actions } from '..';

const initialState: ScreensaverState = {
	showScreensaver: false,
	showTimeoutWarning: false,
};

export function screensaverReducer(state = initialState, action: Actions): ScreensaverState {
	switch (action.type) {
		case SHOW_SCREENSAVER: {
			if (!action.value) {
				return {
					...state,
					showScreensaver: action.value,
				};
			}

			return {
				...state,
				showScreensaver: action.value,
			};
		}
		case SHOW_TIMEOUT_WARNING: {
			return { ...state, showTimeoutWarning: action.value.show };
		}
		default:
			return state;
	}
}
